import UserAppContext from '../../hook/UserAppContext'
import './banner.css'

const Banner = () => {

      const {user, data} = UserAppContext()
      const {banners} = user.user 
      const banner = banners.data ? data.banner.image : banners[0].image
      const title = banners.data ? data.banner.title : banners[0].title

      return (
            <div className="banner_content">
                  <img src={banner} alt={title} />
            </div>
      )
}

export default Banner
